import { Component, Input } from '@angular/core';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import {
  type CalculateComponentRendering,
  CalculateComponentContent,
} from '@innogy/become-a-customer/shared/interfaces';
import type { TypedComponentRendering } from '@core/jss-models';
import { FormGroupControls, FormGroupState, NgrxFormsModule } from 'ngrx-forms';
import { JssPlatformService } from '@core/jss-platform';
import {
  InputGroupComponent,
  NumberComponent,
  InputErrorComponent,
  CommonUiFormsModule,
} from '@innogy/common-ui/forms';
import { TrackLinkDirective } from '@analytics/events';
import { CommonModule } from '@angular/common';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import {
  CrntIcon,
  CrntFormControlLabel,
  CrntFormControl,
  CrntTextInput,
  CrntFormControlValidationMessage,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  IsInvalidPipe,
  IsValidPipe,
  stringNumberConverterForLocale,
} from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-calculate-form-solar',
  templateUrl: './calculate-form-solar.component.html',
  styleUrls: [
    './calculate-form-solar.component.ed.scss',
    './calculate-form-solar.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    InputGroupComponent,
    NumberComponent,
    InputErrorComponent,
    AutomationIdDirective,
    IsInvalidPipe,
    IsValidPipe,
    TrackLinkDirective,
    ToolTipComponent,
    CrntIcon,
    CommonUiFormsModule,
    NgrxFormsModule,
    CrntFormControlLabel,
    CrntFormControl,
    CrntTextInput,
    CrntFormControlValidationMessage,
  ],
})
export class CalculateFormSolarComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState?: FormGroupState<FullCalculateFormValues>;

  constructor(private readonly jssPlatformservice: JssPlatformService) {}

  get isXpEditorActive() {
    return this.jssPlatformservice.isEditorActive();
  }

  public readonly _stringNumberConverter =
    stringNumberConverterForLocale('nl-NL');
}
